import { useSelector } from 'react-redux';
import React from 'react';

import Profile from './profile';
import ContainerSectionMobile from '../../components/containerSectionMobile';
import ContainerSectionDesktop from '../../components/containerSectionDesktop';

import './profileScreen.scss';

const ProfileScreen = () => {
  const isMobileDevice = useSelector((state) => state.mediaQuery.isMobileDevice);

  return (
    isMobileDevice ? (
      <ContainerSectionMobile className="profile-information">
        <Profile />
      </ContainerSectionMobile>
    ) : (
      <ContainerSectionDesktop>
        <Profile />
      </ContainerSectionDesktop>
    )
  );
};

export default ProfileScreen;
